
import { defineComponent, PropType } from "vue";
import router from "@/router";
import store from "@/store";

import {
    IPiarModel,
    IStudentsModel,
    ICourseGroupsModel,
    IPeriodsModel,
    IAcademicYearModel,
    IHeadquartersModel,
    IIndividualEnrollmentModel,
} from "@/interfaces/modules";

import StudentsService from "@/api/Aula/StudentsService";
import CourseGroupsService from "@/api/Aula/CourseGroupsService";
import PeriodsService from "@/api/Configuration/PeriodsService";
import PiarService from "@/api/Piar/PiarService";
import IndividualEnrollmentService from "@/api/Enrollment/IndividualEnrollmentService";
import AcademicYearService from "@/api/Configuration/AcademicYearService";
import HeadquartersService from "@/api/Configuration/HeadquartersService";

import { SHOW_PRESCHOOL } from "@/enums";

export default defineComponent({
    name: "PiarBasicDataTab",
    props: {
        piar: {
            type: Object as PropType<IPiarModel | null>,
            required: false,
            default: null,
        },
        isNew: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ["saved"],
    data() {
        return {
            form: {
                loading: true,
                dialog: false,
                valid: false,
                wasValidated: false,
                record: {} as IPiarModel,
                rules: {
                    required: [(v: any) => !!v || "Este campo es requerido"],
                },
            },
            students: [] as IStudentsModel[],
            periods: [] as IPeriodsModel[],
            academicYears: [] as IAcademicYearModel[],
            courseGroups: [] as ICourseGroupsModel[],
            headquarters: [] as IHeadquartersModel[],

            loading: true,
            saving: false,
        };
    },
    computed: {
        formRecord(): any {
            return this.$refs.formRecord;
        },
    },
    async mounted() {
        await this.load();

        if (this.piar?.Id) {
            // Modo edición: cargar desde la API para tener el registro completo
            this.form.record = await PiarService.GetById(this.piar.Id);
        } else {
            // Modo nuevo: inicializar valores por defecto
            this.form.record = {} as IPiarModel;
        }

        this.changeValuesLoad();
    },
    methods: {
        async load() {
            this.loading = true;
            try {
                let _students = await StudentsService.GetStudents();
                this.students = _students.filter(s => s.IsPIAR);
                this.courseGroups = await CourseGroupsService.GetCourseGroups();
                this.periods = await PeriodsService.GetPeriods();
                this.academicYears = await AcademicYearService.GetAcademicYears();
                this.headquarters = await HeadquartersService.GetHeadquarters();
            } finally {
                this.loading = false;
            }
        },

        async changeValuesLoad() {
            if (this.form.record.StudentId > 0) {
                let enrollment = await IndividualEnrollmentService.GetByStudentLastEnrollment(this.form.record.StudentId as any) as IIndividualEnrollmentModel;
                this.form.record.AcademicYearId = enrollment.AcademicYearId;
                this.form.record.HeadquarterId = enrollment?.HeadquarterId || 0;
                this.form.record.CourseGroupId = enrollment.CourseGroupId;
            }
        },

        async save() {
            try {
                this.saving = true;
                this.form.loading = true;

                const res = await PiarService.Post(this.form.record);

                store.dispatch("core/popupDialog", {
                    text: "Registro guardado con éxito.",
                    type: "success",
                    showCancelButton: false,
                });
                this.form.record = res;
                this.form.loading = false;
                this.saving = false;

                router.push(`/piar/piar-basic-data/${this.form.record.Id}`);
                location.reload();
            } catch (err: any) {
                this.form.loading = false;
                this.saving = false;

                store.dispatch("core/popupDialog", {
                    text: `Error: ${err?.response?.data?.message || err?.message}`,
                    type: "error",
                    showCancelButton: false,
                });
            }
        },

        cancel(_file?: any) {
            // Puedes cambiar esto a un nombre de ruta específico si ya lo tienes definido
            router.back();
        },
    },
});
